import React from "react";

import { Badge } from "@/components/ui/badge";
import { cn, getCityColor } from "@/lib/utils";

export const ColoredBadge = ({ getValue, colors }: any) => {
  const color = React.useMemo(
    () =>
      !getValue()
        ? ""
        : colors && colors?.[getValue()]
          ? colors[getValue()]
          : getCityColor(getValue()),
    [getValue()],
  );

  return (
    <Badge
      style={{
        backgroundColor: color,
      }}
      className={cn("badge badge-primary", color)}
    >
      {getValue()}
    </Badge>
  );
};
